"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _react = _interopRequireDefault(require("react"));

var _RequiredOnboardingSubtext = _interopRequireDefault(require("../calculator/RequiredOnboardingSubtext"));

var _RequiredOnboardingSelectors = require("../../selectors/RequiredOnboardingSelectors");

var _utils = require("../bundle-page/utils");

var SuiteCalcRequiredOnboardingSectionContainer = function SuiteCalcRequiredOnboardingSectionContainer(_ref) {
  var billingNameKey = _ref.billingNameKey,
      activeCurrency = _ref.activeCurrency,
      pricingInfo = _ref.pricingInfo,
      bundleSelections = _ref.bundleSelections;
  var getRequiredOnboardingId = (0, _reactRedux.useSelector)(function (state) {
    return function (merchId) {
      return (0, _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector)(state, merchId);
    };
  });

  if (!pricingInfo || !activeCurrency) {
    return null;
  }

  var merchandiseIds = (0, _utils.bundleMerchandiseIds)(bundleSelections);
  if (!merchandiseIds.some(getRequiredOnboardingId)) return null;
  return _react.default.createElement(_RequiredOnboardingSubtext.default, {
    billingNameKey: billingNameKey,
    pricingInfo: pricingInfo,
    currencyCode: activeCurrency
  });
};

SuiteCalcRequiredOnboardingSectionContainer.propTypes = {
  bundleSelections: _propTypes.default.object.isRequired,
  billingNameKey: _propTypes.default.string.isRequired,
  activeCurrency: _propTypes.default.string,
  pricingInfo: _propTypes.default.object
};
var _default = SuiteCalcRequiredOnboardingSectionContainer;
exports.default = _default;
module.exports = exports.default;